import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // スライドインアニメーション
    this.element.style.transform = "translateY(20px)"
    this.element.style.opacity = "0"
    this.element.style.transition = "transform 0.3s ease-out, opacity 0.3s ease-out"

    requestAnimationFrame(() => {
      this.element.style.transform = "translateY(0)"
      this.element.style.opacity = "1"
    })

    // 3秒後にフェードアウト→DOM削除
    this.timeout = setTimeout(() => this.dismiss(), 3000)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.style.transition = "transform 0.3s ease-in, opacity 0.3s ease-in"
    this.element.style.transform = "translateY(20px)"
    this.element.style.opacity = "0"

    setTimeout(() => this.element.remove(), 300)
  }
}
